import { useParams } from 'react-router-dom';

interface AnnotationToolRouteParams {
  extraction_token: string;
  task_token: string;
}

export const useToolParams = (): AnnotationToolRouteParams => {
  return useParams<AnnotationToolRouteParams>();
};
